/* eslint-disable @typescript-eslint/ban-types */
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Types } from 'mongoose';
import { BehaviorSubject, Observable, of } from 'rxjs';

import { RULE_CRITERIA, TO_RULE_TYPE, URLS } from '@shared/constants';
import { MessageGroupResponseDTO } from '@shared/dtos';
import {
  CommonResponseDTO,
  IBaseEntity,
  IConnection,
  IIdentity,
  IRole,
} from '@shared/interfaces';

export interface MemberDTO {
  name?: string;
  account_type?: string;
  identity_id?: string;
  isGroup?: boolean;
}

export interface RuleUserMember {
  member_type: string;
  key?: string; // TODO:@nipun remove this
  value?: string; // TODO:@nipun  remove this
  member_id: string;
}

export interface CriteriaDTO {
  criteria: string;
  members: RuleUserMember[];
}

export interface IRGDTO {
  key: string;
  value: string;
}

export interface IRuleUser {
  user_type: TO_RULE_TYPE;
  user_id: string;
}

interface MessageRuleDTO extends IBaseEntity {
  to_id: Types.ObjectId | string;
  selected_type: TO_RULE_TYPE;
  user_role?: string;
  rule_user: IRuleUser; //remouve this
  is_deleted?: boolean;
  is_active: boolean;
  identity_rules: IRuleCriteria;
  role_rules: IRuleCriteria;
  group_rules: IRuleCriteria;
  identity?: IIdentity;
  connection?: IConnection;
  role?: IRole;
  group?: MessageGroupResponseDTO;
}

interface IRuleCriteria {
  criteria?: RULE_CRITERIA;
  members?: string[];
}

export interface IMessageRuleDTO extends MessageRuleDTO {
  _id?: string;
}

export interface IRuleMembers {
  identity_rules: IRuleCriteria;
  role_rules: IRuleCriteria;
  group_rules: IRuleCriteria;
}

export type MembersList = IConnection[] | IRole[] | MessageGroupResponseDTO[];

@Injectable({
  providedIn: 'root',
})
export class MessageRuleService {
  public readonly dataStore = new BehaviorSubject<IMessageRuleDTO[]>(undefined);

  constructor(private http: HttpClient) {}

  addNewMessageRule(
    messageRuleData: IMessageRuleDTO,
    successCallback?: Function
  ) {
    this.http
      .post(URLS.MESSAGE_RULES_BASE_URL, messageRuleData)
      .subscribe(() => {
        this.getAllMessageRules(successCallback);
      });
  }

  updateMessageRule(
    id: string,
    messageRuleData: IMessageRuleDTO,
    successCallback?: Function
  ) {
    const url = `${URLS.MESSAGE_RULES_BASE_URL}/${id}`;
    this.http.put(url, messageRuleData).subscribe(() => {
      this.getAllMessageRules(successCallback);
    });
  }

  deleteMessageRule(id: string, successCallback?: Function) {
    const url = `${URLS.MESSAGE_RULES_BASE_URL}/${id}`;
    this.http.delete(url).subscribe(() => {
      this.getAllMessageRules(successCallback);
    });
  }

  getAllMessageRules(successCallback?: Function) {
    return this.http
      .get<CommonResponseDTO<IMessageRuleDTO[]>>(URLS.MESSAGE_RULES_BASE_URL)
      .subscribe((res) => {
        this.dataStore.next(res.data);
        successCallback();
      });
  }

  getAllMessageRulesCustom(): Observable<CommonResponseDTO<IMessageRuleDTO[]>> {
    return this.http.get<CommonResponseDTO<IMessageRuleDTO[]>>(
      URLS.MESSAGE_RULES_BASE_URL
    );
  }

  enableDisableRule(
    id: string,
    is_active: boolean,
    successCallback?: Function
  ): void {
    const url = `${URLS.MESSAGE_RULES_BASE_URL}/${id}/enable-disable`;
    this.http
      .put<CommonResponseDTO<IMessageRuleDTO>>(url, { is_active })
      .subscribe(() => {
        this.getAllMessageRules(successCallback);
      });
  }

  getFilteredRuleUsers(
    params?: HttpParams
  ): Observable<
    CommonResponseDTO<IConnection[] | IRole[] | MessageGroupResponseDTO[]>
  > {
    const config = { params };
    const url = `${URLS.MESSAGES_BASE_URL}/members`;
    return this.http.get<
      CommonResponseDTO<IConnection[] | IRole[] | MessageGroupResponseDTO[]>
    >(url, config);
  }

  getAllowedOrRestrictedData(
    toMembersIds: string,
    toRuleType: TO_RULE_TYPE
  ): Observable<CommonResponseDTO<MembersList>> {
    if (!toMembersIds) {
      return of({
        data: [],
        message: '',
        success: true,
        statusCode: 200,
      } as CommonResponseDTO<MembersList>);
    }
    const url = `${URLS.MESSAGE_RULES_BASE_URL}/rule-members`;

    return this.http.get<CommonResponseDTO<MembersList>>(url, {
      params: { toMembersIds, toRuleType },
    });
  }
}
